/* eslint max-lines: 0  max-len: 0 */
import { Component } from 'lib'

const unicodes = {
  bullet: '\u2022',
  dash: '\u2013',
  hyphen: '\u002d',
  spacedHyphen: '\u00A0\u002d\u00A0',
  space: '\u00A0',
  rightDoubleQuote: '\u201d',
  euro: '\u20ac',
  dollar: '\u0024'
}

class Icon extends Component {
  static unicode (code) {
    return unicodes[code]
  }

  barons () {
    return (
      <svg
        class="icon"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        xmlns="https://www.w3.org/2000/svg">
        <path
          class="shape"
          fill="#555d64"
          d="M17,12.5049 C17,13.3299 16.331,13.9999 15.504,13.9999 L15.496,13.9999
        C14.669,13.9999 14,13.3299 14,12.5049 L14,12.4949 C14,11.6699
        14.669,10.9999 15.496,10.9999 L15.504,10.9999 C16.331,10.9999 17,11.6699
        17,12.4949 L17,12.5049 Z M13,10.0079 C13,10.5559 12.556,10.9999
        12.008,10.9999 L11.992,10.9999 C11.444,10.9999 11,10.5559 11,10.0079
        L11,9.9919 C11,9.4439 11.444,8.9999 11.992,8.9999 L12.008,8.9999
        C12.556,8.9999 13,9.4439 13,9.9919 L13,10.0079 Z M13,15.0099 C13,15.5569
        12.557,15.9999 12.01,15.9999 L11.99,15.9999 C11.443,15.9999 11,15.5569
        11,15.0099 L11,14.9899 C11,14.4429 11.443,13.9999 11.99,13.9999
        L12.01,13.9999 C12.557,13.9999 13,14.4429 13,14.9899 L13,15.0099
        Z M10,12.5139 C10,13.3349 9.334,13.9999 8.514,13.9999 L8.486,13.9999
        C7.666,13.9999 7,13.3349 7,12.5139 L7,12.4859 C7,11.6659 7.666,10.9999
        8.486,10.9999 L8.514,10.9999 C9.334,10.9999 10,11.6659 10,12.4859
        L10,12.5139 Z M22,5.9999 L15,1.9999 L15,3.9999 L18,6.9999 L16,8.9999
        L12,4.9999 L8,8.9999 L6,6.9999 L9,3.9999 L9,1.9999 L2,5.9999 L6,10.9999
        L2,14.9999 L5,18.9999 L5,14.9999 L7,14.9999 L8,19.9999 L10,21.9999
        L10,17.9999 L12,19.9999 L14,17.9999 L14,21.9999 L16,19.9999 L17,14.9999
        L19,14.9999 L19,18.9999 L22,14.9999 L18,10.9999 L22,5.9999 Z"
        />
      </svg>
    )
  }

  league () {
    return (
      <svg
        class="icon"
        width="28px"
        height="28px"
        viewBox="0 0 228 190"
        xmlns="https://www.w3.org/2000/svg">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path
            d="M37.39981,102.125 C37.39981,91.9315 39.41381,82.20255
        43.03711,73.2944 L43.03711,50.02225 C32.32871,64.6209 25.99981,82.63195
        25.99981,102.125 C25.99981,121.61805 32.32871,139.63005
        43.03711,154.2287 L43.03711,130.9556 C39.41381,122.04745
        37.39981,112.3185 37.39981,102.125"
            id="Fill-1"
            fill="#C79E57"
          />
          <path
            d="M114.191635,25.333175 C156.534085,25.333175
        190.982985,59.782075 190.982985,102.124525 C190.982985,121.106475
        184.045135,138.488625 172.592885,151.905475 L186.994885,151.905475
        C196.701035,137.737175 202.382985,120.596325 202.382985,102.124525
        C202.382985,53.418025 162.899085,13.933175 114.191635,13.933175
        C111.241885,13.933175 108.327285,14.081375 105.451635,14.364475
        L105.451635,25.845225 C108.322535,25.518425 111.235235,25.333175
        114.191635,25.333175"
            id="Fill-4"
            fill="#C79E57"
          />
          <polygon
            fill="#C79E57"
            points="40.376445 0 54.436445 16.91 54.436445
        164.35 39.711445 190 168.247395 190 188.576445 163.305 94.051445
        163.305 94.051445 0"
          />
        </g>
      </svg>
    )
  }

  towers () {
    if (this.props.size === 'small') {
      return (
        <svg
          class="icon"
          width="16px"
          height="16px"
          viewBox="0 0 16 16"
          xmlns="https://www.w3.org/2000/svg">
          <path
            class="shape"
            fill="#555d64"
            d="M6,1.0004 L6,4.0004 L5,3.4994
          L3.5,4.4994 L4.5,6.9994 L8,8.9994 L11.5,6.9994 L12.5,4.4994
          L10.999,3.4994 L10,4.0004 L10,1.0004 L6,1.0004 Z M7,4.0004 L7,2.0004
          L9,2.0004 L9,4.0004 L8,5.0004 L7,4.0004 Z M8,10.0004 L10,8.9994
          L9.5,13.0004 L11,13.0004 L11,14.0004 L5,14.0004 L5,13.0004
          L6.5,13.0004 L6,8.9994 L8,10.0004 Z"
          />
        </svg>
      )
    }
    else {
      return (
        <svg
          class="icon"
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          xmlns="https://www.w3.org/2000/svg">
          <path
            class="shape"
            fill="#555d64"
            d="M9.0004,1.0004 L9.0004,5.9994 L6.9994,5.0004 L4.0004,6.9994
          L4.9994,11.0004 L12.0004,14.9994 L19.0004,11.0004 L20.0004,6.9994
          L16.9994,5.0004 L14.9994,5.9994 L14.9994,1.0004 L9.0004,1.0004
          Z M11.0004,5.9994 L11.0004,3.0004 L13.0004,3.0004 L13.0004,5.9994
          L12.0004,6.9994 L11.0004,5.9994 Z M15.9994,8.9994 L12.0004,12.0004
          L7.9994,8.9994 L12.0004,10.0004 L15.9994,8.9994 Z M12.0001,16.9997
          L16.0001,14.9997 L15.0001,21.0007 L16.9991,21.0007 L16.9991,22.9997
          L7.0001,22.9997 L7.0001,21.0007 L9.0001,21.0007 L7.9991,14.9997
          L12.0001,16.9997 Z"
          />
        </svg>
      )
    }
  }

  inhibitors () {
    return (
      <svg
        class="icon"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        xmlns="https://www.w3.org/2000/svg">
        <path
          class="shape"
          fill="#555d64"
          d="M12,2 C17.522,2 22,6.478 22,12 C22,17.522 17.522,22 12,22
        C6.477,22 2,17.522 2,12 C2,6.478 6.477,2 12,2 Z M12,4 C7.639,4 4,7.635
        4,12 C4,16.365 7.639,20 12,20 C16.362,20 20,16.365 20,12 C20,7.635
        16.362,4 12,4 Z M12,8 L16,12 L12,16 L8,12 L12,8 Z"
        />
      </svg>
    )
  }

  kills () {
    if (this.props.size === 'small') {
      return (
        <svg
          class="icon"
          width="16px"
          height="16px"
          viewBox="0 0 16 16"
          xmlns="https://www.w3.org/2000/svg">
          <g class="shape" fill="#555d64" fill-rule="evenodd">
            <polygon
              points="8 9.43 13 5.78 13 3 10.22 3 6.57 8 6.57 8 6.57 8
            6.57 9.43 4.43 7.29 3.71 9.43 4.63 10.34 3 11.97 4.03 13 5.66 11.37
            6.57 12.29 8.71 11.57 6.57 9.43 8 9.43 8 9.43"
            />
          </g>
        </svg>
      )
    }
    else {
      return (
        <svg
          class="icon"
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          xmlns="https://www.w3.org/2000/svg">
          <path
            class="shape"
            fill="#555d64"
            d="M16,3 L9.001,12 L9.001,13.5 L6,10.5 L5,14 L6.501,15.5 L3,19 L3,21
          L5,21 L8.5,17.5 L10.001,19 L13.501,18 L10.5,15 L12,15 L21,8 L21,3
          L16,3 Z M10.5,12.75 L17.001,6 L18.001,6 L18.001,7 L11.251,13.5
          L10.5,13.5 L10.5,12.75 Z"
          />
        </svg>
      )
    }
  }

  cloudDragon () {
    return (
      <svg
        class="icon"
        width="18px"
        height="18px"
        viewBox="0 0 14 18"
        xmlns="https://www.w3.org/2000/svg">
        <path
          class="shape"
          fill="#ADD2ED"
          d="M3.839325,1
        C3.839325,1 8.2243,2.667575 8.2243,6.623975 C8.2243,10.4591
        1.939175,10.2722 1.939175,14.969375 C1.939175,15.96705 2.63515,17.3401
        2.63515,17.3401 C2.63515,17.3401 0,15.71505 0,13.447575 C0,9.575175
        4.95565,11.117975 4.95565,4.486 C4.95565,2.01885
        3.839325,1 3.839325,1 M12.4478333,8.7884625 C12.4478333,10.2183875
        11.3421833,12.5586625 8.51803332,12.5586625 C4.30910832,12.5586625
        3.72618332,14.4448125 3.72618332,14.4448125 C2.98505832,11.7594375
        10.5375333,9.9887875 10.5375333,5.9735875 C10.5375333,4.1395875
        9.63558332,3.1321125 9.63558332,3.1321125 C9.63558332,3.1321125
        12.4478333,5.0774125 12.4478333,8.7884625 M4.55,15.75691
        C5.138175,14.079535 6.3917,13.71641 6.3917,13.71641 C6.3917,13.71641
        7.9394,14.238085 8.6177,14.238085 C11.88495,14.238085
        13.846175,10.297785 13.846175,10.297785 C13.846175,10.297785
        14.870975,13.87391 11.552275,17.450035 C11.552275,17.450035
        9.60295,15.161035 7.14315,15.161035 C5.651975,15.161035 4.55,15.75691
        4.55,15.75691"
        />
      </svg>
    )
  }

  elderDragon () {
    return (
      <svg
        class="icon"
        width="18px"
        height="18px"
        viewBox="0 0 14 18"
        xmlns="https://www.w3.org/2000/svg">
        <path
          class="shape"
          fill="#C9BCDC"
          d="M9.282525,10.64335
        C8.611225,11.44178.069075,11.3129 8.069075,11.3129 L8.5337,10.192725
        L9.721425,9.252625 C9.721425,9.252625 9.953825,9.845 9.282525,10.64335
        M7.843325,16.17685 C7.843325,16.17685 7.503475,15.613875
        7.33355,15.332475 L6.999825,15.84645 L6.6661,15.332475
        C6.496175,15.613875 6.156325,16.17685 6.156325,16.17685
        C6.156325,16.17685 5.438825,15.278575 5.438825,14.298925
        C5.438825,13.31945 5.6182,12.50605 5.6182,12.50605 L6.107325,13.987425
        L6.49425,13.6978 C6.49425,13.6978 6.605025,14.05165 6.999825,14.5693
        C7.39445,14.05165 7.505225,13.6978 7.505225,13.6978 L7.892325,13.987425
        L8.381275,12.50605 C8.381275,12.50605 8.560825,13.31945
        8.560825,14.298925 C8.560825,15.278575 7.843325,16.17685
        7.843325,16.17685 M4.149775,9.252625 L5.424125,10.192725
        L5.922875,11.4956 C5.922875,11.4956 4.149775,11.213325
        4.149775,9.252625 M9.493575,-0.0005 L9.02265,0.513475 L9.194325,4.331625
        C9.194325,4.331625 10.231725,5.096725 10.231725,6.0405
        C10.231725,6.730525 9.767975,7.222975 9.276225,7.222975
        C8.56765,7.222975 8.02585,6.47275 8.29395,5.55505 L7.000175,3.375775
        L6.999825,3.375775 L5.705875,5.55505 C5.973975,6.47275
        5.432175,7.222975 4.723775,7.222975 C4.232025,7.222975
        3.768275,6.730525 3.768275,6.0405 C3.768275,5.096725 4.8055,4.331625
        4.8055,4.331625 L4.977175,0.513475 L4.50625,-0.0005 C4.50625,3.448925
        0,6.669975 0,10.24505 C0,12.510425 2.260475,13.944725 2.260475,16.217625
        C2.260475,16.217625 2.6649,15.643625 2.6649,14.24555 C2.6649,12.8473
        2.1504,12.74125 2.1504,11.87395 C2.1504,11.006825 2.927225,10.17225
        2.927225,10.17225 C2.927225,11.666925 4.60985,12.917825
        4.60985,13.628675 C4.60985,14.612525 5.48485,17.4995 7,17.4995
        C8.514975,17.4995 9.39015,14.612525 9.39015,13.628675
        C9.39015,12.917825 11.0726,11.666925 11.0726,10.17225
        C11.0726,10.17225 11.849425,11.006825 11.849425,11.87395
        C11.849425,12.74125 11.334925,12.8473 11.334925,14.24555
        C11.334925,15.643625 11.73935,16.217625 11.73935,16.217625
        C11.73935,13.944725 14,12.510425 14,10.24505 C14,6.669975
        9.493575,3.448925 9.493575,-0.0005"
        />
      </svg>
    )
  }

  infernalDragon () {
    return (
      <svg
        class="icon"
        width="18px"
        height="18px"
        viewBox="0 0 14 18"
        xmlns="https://www.w3.org/2000/svg">
        <path
          class="shape"
          fill="#F26C23"
          d="M6.185725,0 C6.185725,0
        6.68325,2.9099
        6.23805,3.343375 C5.79285,3.77685 2.274125,7.10675 2.274125,7.10675
        L1.1004,5.78095 L0,9.82625 C0,9.82625 1.6954,11.38935 2.48955,14.728
        L7,17 L13.4652,12.0666 L14,9.041025 L12.7162,7.765625 C12.7162,7.765625
        12.951225,9.4052 12.354825,9.4052 C11.75825,9.4052 10.6764,6.8957
        9.88715,6.8957 C9.098075,6.8957 8.401575,7.10115 6.9097,7.4508
        C5.718475,7.7301 5.26015,9.698675 5.12365,10.48075 C5.090225,10.6729
        5.171425,10.8668 5.33435,10.97985 L6.9097,12.347825 C6.9097,12.347825
        8.385125,11.378325 8.385125,10.723825 C8.385125,10.221575
        7.146825,10.252025 7.146825,9.30265 C7.146825,8.75 7.6391,8.52985
        8.262625,8.52985 C9.99355,8.52985 10.6708,10.5721 10.6708,10.5721
        C9.404675,13.03785 6.9951,14.595 6.9951,14.595 C6.9951,14.595
        3.436475,12.154625 3.436475,10.63195 C3.436475,6.427225 8.33595,5.31125
        8.33595,5.31125 L8.98555,3.1598 L6.185725,0 Z"
        />
      </svg>
    )
  }

  mountainDragon () {
    return (
      <svg
        class="icon"
        width="18px"
        height="18px"
        viewBox="0 0 14 18"
        xmlns="https://www.w3.org/2000/svg">
        <path
          class="shape"
          fill="#A8805D"
          d="M3,4.5 L6,16 L5,17 L1,12.0302388
        L1,7.07612197 L3,4.5 Z M6.50012207,13 L4.5,3 L6,1 L8,1 L9.5,3 L7.5,13
        L6.50012207,13 Z M11,4.5 L13,7.07612197 L13,12.0302388 L9,17 L8,16
        L11,4.5 Z"
        />
      </svg>
    )
  }

  oceanDragon () {
    return (
      <svg
        class="icon"
        width="18px"
        height="18px"
        viewBox="0 0 14 18"
        xmlns="https://www.w3.org/2000/svg">
        <path
          class="shape"
          fill="#67C4B0"
          d="M14,11.272025 C14,9.952875
        12.87125,9.44695 12.87125,9.44695 C12.87125,9.44695 13.38225,8.4323
        13.38225,7.648825 C13.38225,4.919525 11.339125,2 7.911225,2 C3.984225,2
        2.41325,6.1566 2.41325,6.1566 C2.41325,6.1566 1.932875,5.452575
        2.08425,3.761025 C2.08425,3.761025 0,5.522225 0,9.19355 C0,12.138275
        2.055375,15.65 5.7512,15.65 C8.239,15.65 9.910075,13.554725
        9.910075,11.2869 C9.910075,9.141925 8.16095,7.872475 6.523125,7.872475
        C5.453525,7.872475 4.567675,8.64755 4.567675,8.64755 C4.86745,7.1303
        6.50195,6.52375 6.50195,6.52375 C7.092925,3.727425 10.506825,4.049425
        10.506825,4.049425 C10.506825,4.049425 9.08005,4.797375 8.588475,6.1524
        C8.588475,6.1524 12.0211,7.341525 12.0211,11.19765 C12.0211,13.94445
        10.213875,15.407275 10.213875,15.407275 C10.213875,15.407275
        11.930625,14.51145 13.0858,12.63615 C13.323975,12.94065
        13.347075,13.3806 13.347075,13.3806 C13.347075,13.3806
        14,12.591175 14,11.272025"
        />
      </svg>
    )
  }

  hextechDragon () {
    return (
      <svg
        width="18px"
        height="18px"
        viewBox="0 0 24 24"
        class="icon"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          class="shape"
          fill="#81D9F5"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.4142 3V5.78423L20 12.2808L13.4142 18.7773L11.0572 21V19.2414L4
            12.2808L11.0572 5.32019L13.4142 3ZM15.1231 10.1346L17 11.9822L12
            16.9041L7.00003 11.9822L8.87694 10.1346L12 13.2089L15.1231
            10.1346ZM14.0624 9.09049L12 11.1207L9.9376 9.09055L12 7.06034L14.0624 9.09049Z"
        />
      </svg>
    )
  }

  chemtechDragon () {
    return (
      <svg
        width="18px"
        height="18px"
        viewBox="0 0 24 24"
        class="icon"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          class="shape"
          fill="#A4B72B"
          d="M15.8377 6.24546C16.8672 6.24546 17.2548 5.31013 16.7519 4.29806C19.0471
          5.60353 21.6148 9.13739 19.0471 11.381C16.9304 13.2303 14.7314 12.2534
          12.9652 10.2592C11.8045 8.94874 8.13507 8.00911 8.13507 10.739C8.13507
          12.2439 9.19042 13.1114 10.6993 13.3874C10.2969 13.1114 9.51962 12.1294
          10.2969 11.1793C11.2292 10.0399 13.2537 12.3425 14.7229 13.1114C16.456
          14.0183 18.2637 12.9588 19.2522 13.1771C22.3776 13.8678 21.231 19.3125 16.456
          18.6449C14.197 18.3291 12.8524 17.8037 11.9707 18.6449C10.8823 19.6832 13.3545
          20.8856 14.2515 20.8856C12.3763 21.5236 7.06641 19.3849 9.41883 17.1584C10.0521
          16.559 10.6749 16.3194 11.184 16.3316C11.184 17.5007 12.9846 17.2448 13.7648
          16.9625C15.4769 16.3432 14.9583 14.428 13.3163 14.0183C11.2766 13.5096 10.1287
          17.3467 5.56753 15.8745C3.83222 15.3145 3 13.9529 3 12.6649C3 11.3768 3.84781
          10.592 4.25016 10.0399C3.9193 7.3383 4.8087 5.43267 6.15552 4.29806C8.00363
          2.74117 11.9707 2.39384 13.2701 4.31965C13.6292 4.85177 14.4026 6.24546 15.8377 6.24546Z"
        />
      </svg>
    )
  }

  cs () {
    return (
      <svg
        class="icon"
        width="16px"
        height="16px"
        viewBox="0 0 16 16"
        xmlns="https://www.w3.org/2000/svg">
        <path
          class="shape"
          fill="#555d64"
          d="M8.5,2h-1L3,9l5,5,5-5ZM5,8,6,7,8,9l2-2,1,1L8,12.5Z"
        />
      </svg>
    )
  }

  gold () {
    return (
      <svg
        class="icon"
        width="16px"
        height="16px"
        viewBox="0 0 16 16"
        xmlns="https://www.w3.org/2000/svg">
        <g class="shape" fill="#555d64" fill-rule="evenodd">
          <path
            d="M13,6.86C13,8,11.21,9,9,9S5,8,5,6.86V5.14C5,4
          ,6.79,3,9,3s4,1,4,2.14Z"
          />
          <path
            d="M7,7.71a4,4,0,0,1,2.4.64v1.3a4,4,0,0,1-2.4.64,4
          ,4,0,0,1-2.4-.64V8.35A4,4,0,0,1,7,7.71M7,6C4.79,6,3,7,3
          ,8.14V9.86C3,11,4.79,12,7,12s4-1,4-2.14V8.14C11,7,9.21,6,7,6Z"
          />
        </g>
      </svg>
    )
  }

  arrow () {
    if (this.props.direction === 'up') {
      return (
        <svg
          class="icon"
          width="16px"
          height="16px"
          viewBox="0 0 16 16"
          xmlns="https://www.w3.org/2000/svg">
          <g
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
            transform="rotate(180 8, 8)">
            <mask fill="white">
              <polygon
                points="11.5 5 7.499 9 3.5 5.001 2 6.499 7.499 12 12.999
            6.499"
              />
            </mask>
            <polygon
              class="shape"
              fill="#231F20"
              points="11.5 5 7.499 9 3.5
          5.001 2 6.499 7.499 12 12.999 6.499"
            />
          </g>
        </svg>
      )
    }
    else if (this.props.direction === 'right') {
      return (
        <svg
          class="icon"
          width="10px"
          height="15px"
          viewBox="0 0 10 15"
          xmlns="http://www.w3.org/2000/svg">
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g transform="translate(-320.000000, -17.000000)">
              <g transform="translate(325.000000, 24.000000) rotate(-90.000000) translate(-325.000000, -24.000000) translate(313.000000, 12.000000)">
                <mask fill="white">
                  <polygon points="6 7 4 9.005 11.495 16.505 19.001 9.005 17 7.005 11.501 12.504"/>
                </mask>
                <polygon
                  class="shape"
                  fill="#687077"
                  fill-rule="evenodd"
                  points="6 7 4 9.005 11.495 16.505 19.001 9.005 17 7.005 11.501 12.504"
                />
              </g>
            </g>
          </g>
        </svg>
      )
    }
    else if (this.props.direction === 'down') {
      return (
        <svg
          class="icon"
          width="16px"
          height="16px"
          viewBox="0 0 16 16"
          xmlns="https://www.w3.org/2000/svg">
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <mask fill="white">
              <polygon
                points="11.5 5 7.499 9 3.5 5.001 2 6.499 7.499 12 12.999
            6.499"
              />
            </mask>
            <polygon
              class="shape"
              fill="#231F20"
              points="11.5 5 7.499 9 3.5
          5.001 2 6.499 7.499 12 12.999 6.499"
            />
          </g>
        </svg>
      )
    }
    else if (this.props.direction === 'left') {
      return (
        <svg
          class="icon"
          width="10px"
          height="15px"
          viewBox="0 0 10 15"
          xmlns="http://www.w3.org/2000/svg">
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g transform="translate(-320.000000, -17.000000)">
              <g transform="translate(325.000000, 24.000000) scale(-1, 1) rotate(-90.000000) translate(-325.000000, -24.000000) translate(313.000000, 12.000000)">
                <mask fill="white">
                  <polygon points="6 7 4 9.005 11.495 16.505 19.001 9.005 17 7.005 11.501 12.504"/>
                </mask>
                <polygon
                  class="shape"
                  fill="#687077"
                  fill-rule="evenodd"
                  points="6 7 4 9.005 11.495 16.505 19.001 9.005 17 7.005 11.501 12.504"
                />
              </g>
            </g>
          </g>
        </svg>
      )
    }
  }

  stats () {
    return (
      <svg
        class="icon"
        width="32px"
        height="32px"
        viewBox="0 0 32 32"
        xmlns="https://www.w3.org/2000/svg">
        <path
          class="shape"
          fill="#555D64"
          d="M12.9999,18.0003 L18.9999,16.0003
        L18.9999,29.0003 L12.9999,29.0003
        L12.9999,18.0003 Z M3,13.9998 L9,11.9998
        L9,28.9998 L3,28.9998 L3,13.9998
        Z M29.0001,3 L29.0001,29 L23.0001,29 L23.0001,5 L29.0001,3 Z"
        />
      </svg>
    )
  }

  items () {
    return (
      <svg
        class="icon"
        width="32px"
        height="32px"
        viewBox="0 0 32 32"
        xmlns="https://www.w3.org/2000/svg">
        <path
          class="shape"
          fill="#555d64"
          d="M15.7223667,6.4997 L5.1999,6.4997 L10.6232523,15.6773717
        L15.7223667,6.4997 Z M16.2776333,6.4997 L21.3773788,15.6785075
        L26.8009,6.4997 L16.2776333,6.4997 Z M21.1874171,16 L10.8139026,16
        L16.0009,24.7777 L21.1874171,16 Z M2.9999,3.9997 L28.9999,3.9997
        L29.9999,6.0007 L16.9999,27.9997 L14.9999,27.9997 L1.9999,6.0007
        L2.9999,3.9997 Z"
        />
      </svg>
    )
  }

  abilities () {
    return (
      <svg
        class="icon"
        width="32px"
        height="32px"
        viewBox="0 0 32 32"
        xmlns="https://www.w3.org/2000/svg">
        <path
          class="shape"
          fill="#555d64"
          d="M14,12 L18.001,6 L5,13 L2,20 L4,28 L12,30 L19,28 L26.001,14 L20,18
        L30,2 L14,12 Z M7.001,20 L9.001,17 L20,12 L15,23 L12,25 L7.001,25
        L7.001,20 Z"
        />
      </svg>
    )
  }

  runes () {
    return (
      <svg
        class="icon"
        width="32px"
        height="32px"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg">
        <path
          class="shape"
          fill="#555d64"
          d="M15.9997,2.0001 L28.0007,9.0001
      L28.0007,23.0001 L15.9997,30.0001 L3.9997,23.0001 L3.9997,9.0001
      L15.9997,2.0001 Z M6.5007,21.5641 L15.9997,27.1051 L25.4997,21.5641
      L25.4997,10.4361 L15.9997,4.8941 L6.5007,10.4361 L6.5007,21.5641 Z
      M21,19 L16,22 L11,19 L11,13 L16,10 L21,13 L21,19 Z"
        />
      </svg>
    )
  }

  eye () {
    return (
      <svg
        class="icon"
        width="48px"
        height="40px"
        viewBox="0 0 48 40"
        xmlns="https://www.w3.org/2000/svg">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g transform="translate(-164.000000, -15.000000)">
            <g transform="translate(164.000000, 11.000000)">
              <mask id="mask-2" fill="white">
                <path
                  id="path-1"
                  d="M14,24 C14,18.478 18.478,14 24,14 C26.04,14
              27.926,14.622 29.508,15.67 L15.668,29.506 C14.622,27.924
              14,26.038 14,24 Z M41.18,4 L44,6.828 L6.82,44 L4,41.172
              L10.24,34.934 L0,26 L0,22 L16,8 L32,8 L34.764,10.416 L41.18,4
              Z M41.205,16.0468 L47.999,21.9868 L47.999,26.0008 L31.999,40.0008
              L17.319,40.0008 L23.365,33.9348 C23.579,33.9488 23.783,34.0008
              23.999,34.0008 C29.523,34.0008 33.999,29.5228 33.999,24.0008
              C33.999,23.7728 33.947,23.5608 33.933,23.3388 L41.205,16.0468 Z"
                />
              </mask>
              <path
                fill="#000000"
                fill-rule="evenodd"
                d="M14,24 C14,18.478
            18.478,14 24,14 C26.04,14 27.926,14.622 29.508,15.67 L15.668,29.506
            C14.622,27.924 14,26.038 14,24 Z M41.18,4 L44,6.828 L6.82,44
            L4,41.172 L10.24,34.934 L0,26 L0,22 L16,8 L32,8 L34.764,10.416
            L41.18,4 Z M41.205,16.0468 L47.999,21.9868 L47.999,26.0008
            L31.999,40.0008 L17.319,40.0008 L23.365,33.9348 C23.579,33.9488
            23.783,34.0008 23.999,34.0008 C29.523,34.0008 33.999,29.5228
            33.999,24.0008 C33.999,23.7728 33.947,23.5608 33.933,23.3388
            L41.205,16.0468 Z"
              />
              <g mask="url(#mask-2)" fill="#555D64" fill-rule="evenodd">
                <rect x="0" y="0" width="48" height="48"/>
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
  }

  close () {
    return (
      <svg
        class="icon"
        width="36px"
        height="36px"
        viewBox="0 0 36 36"
        xmlns="https://www.w3.org/2000/svg">
        <g class="shape" fill="#FFFFFF">
          <polygon
            points="26 8 18 16 10 8 8 10 16 18 8 26 10 28 18 20
          26 28 28 26 20 18 28 10"
          />
        </g>
      </svg>
    )
  }

  restore () {
    return (
      <svg
        class="icon"
        width="36px"
        height="36px"
        viewBox="0 0 36 36"
        xmlns="https://www.w3.org/2000/svg">
        <g class="shape" fill="#FFFFFF" fill-rule="evenodd">
          <path
            d="M4,29 L32,29 L32,7 L4,7 L4,29 Z M6,27 L30,27 L30,9 L6,9
          L6,27 Z"
          />
          <polygon
            points="21.5244 19.4756 19.0004 16.9866 19.0004 22.9996
          17.0004 22.9996 17.0004 16.9866 14.4754 19.4756 13.0004 17.9996
          18.0004 12.9996 23.0004 17.9996"
          />
        </g>
      </svg>
    )
  }

  pause () {
    return (
      <svg
        class="icon"
        width="36px"
        height="36px"
        viewBox="0 0 36 36"
        xmlns="https://www.w3.org/2000/svg">
        <g class="shape" fill="#FFFFFF" fill-rule="evenodd">
          <polygon points="9 28 15 28 15 8 9 8"/>
          <polygon points="21 28 27 28 27 8 21 8"/>
        </g>
      </svg>
    )
  }

  play () {
    return (
      <svg
        class="icon"
        width="36px"
        height="36px"
        viewBox="0 0 36 36"
        xmlns="https://www.w3.org/2000/svg">
        <g class="shape" fill="#FFFFFF" fill-rule="evenodd">
          <polygon points="10 8 10 28 28 18"/>
        </g>
      </svg>
    )
  }

  muted () {
    return (
      <svg
        class="icon"
        height="48px"
        width="48px"
        viewBox="0 0 24 24"
        xmlns="https://www.w3.org/2000/svg">
        <g class="shape" fill="#000000">
          <polygon points="16 17 18 17 18 10.55 16 12.55 16 17"/>
          <polygon points="20 8.54 20 20 22 20 22 6.54 20 8.54"/>
          <polygon points="12 21 14 21 14 14.56 9.79 18.79 12 21"/>
          <polygon
            points="20.59 2 14 8.59 14 3 12 3 7 8 2 8 2 16 6.59 16 2 20.59
          3.41 22 22 3.41 20.59 2"
          />
        </g>
      </svg>
    )
  }

  scrollUp () {
    return (
      <svg
        class="icon"
        width="10px"
        height="10px"
        viewBox="126 10 10 9"
        xmlns="https://www.w3.org/2000/svg">
        <path
          class="shape"
          fill="#5ABBD4"
          fill-rule="evenodd"
          d="M131,10 L127,14 L135.001,14 L131,10 Z M130,19
        L132.001,19 L132.001,14 L130,14 L130,19 Z"
        />
      </svg>
    )
  }

  feedback () {
    return (
      <svg
        class="icon"
        width="32px"
        height="32px"
        viewBox="0 0 32 32"
        xmlns="https://www.w3.org/2000/svg">
        <g class="shape" fill="#555D64">
          <path
            d="M24.17,8,26,9.83V20.17L24.17,22h-9.9l-.56.46L11,
        24.73V22H7.83L6,20.17V9.83L7.83,8H24.17M25,6H7L4,9V21l3,
        3H9v5l6-5H25l3-3V9L25,6Z"
          />
          <polygon points="23 12 9 12 9 14 23 14 23 12 23 12"/>
          <polygon points="20 16 9 16 9 18 20 18 20 16 20 16"/>
        </g>
      </svg>
    )
  }

  navMenuDropdown () {
    return (
      <svg
        class="icon"
        width="22px"
        height="17px"
        viewBox="0 0 22 17"
        xmlns="https://www.w3.org/2000/svg">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g transform="translate(-15.000000, -13.000000)" fill="#555D64">
            <g transform="translate(15.000000, 13.000000)">
              <rect x="0" y="0" width="22" height="3"/>
              <rect x="0" y="7" width="22" height="3"/>
              <rect x="0" y="14" width="22" height="3"/>
            </g>
          </g>
        </g>
      </svg>
    )
  }

  ok () {
    const color = this.props.fill || '#5ABBD4'

    return (
      <svg
        class="icon"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        xmlns="https://www.w3.org/2000/svg">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path
            class="shape"
            d="M14.75,8.5 L10.25,13 L8.5,11.25 L7,12.75
        L10.25,16 L16.25,10 L14.75,8.5 Z M12,19 C8.14,19
        5,15.859 5,12 C5,8.14 8.14,5 12,5 C15.859,5 19,8.14
        19,12 C19,15.859 15.859,19 12,19 Z M12,3 C7.029,3 3,7.029
        3,12 C3,16.971 7.029,21 12,21 C16.971,21 21,16.971 21,12
        C21,7.029 16.971,3 12,3 Z"
            fill={ color }
          />
        </g>
      </svg>
    )
  }

  warn () {
    const color = this.props.fill || '#E7920E'

    return (
      <svg
        class="icon"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        xmlns="https://www.w3.org/2000/svg">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path
            class="shape"
            d="M11,17 L13,17 L13,15 L11,15 L11,17 Z M11,13
        L13,13 L13,7 L11,7 L11,13 Z M12,19 C8.14,19 5,15.859
        5,12 C5,8.14 8.14,5 12,5 C15.859,5 19,8.14 19,12 C19,15.859
        15.859,19 12,19 Z M3,12 C3,16.971 7.029,21 12,21 C16.971,21
        21,16.971 21,12 C21,7.029 16.971,3 12,3 C7.029,3 3,7.029
        3,12 Z"
            fill={ color }
          />
        </g>
      </svg>
    )
  }

  error () {
    const color = this.props.fill || '#DE2F2F'

    return (
      <svg
        class="icon"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          class="shape"
          clip-rule="evenodd"
          fill-rule="evenodd"
          stroke="none"
          fill={ color }
          d="m19.25748,11.7149c0,3.97484 -3.22217,7.19701
          -7.19701,7.19701c-3.9748,0 -7.19701,-3.22217
          -7.19701,-7.19701c0,-3.9748 3.2222,-7.19701
          7.19701,-7.19701c3.97484,0 7.19701,3.2222
          7.19701,7.19701zm1.96282,0c0,5.05884 -4.10099,9.15983
          -9.15983,9.15983c-5.05883,0 -9.15983,-4.10099
          -9.15983,-9.15983c0,-5.05883 4.101,-9.15983
          9.15983,-9.15983c5.05884,0 9.15983,4.101
          9.15983,9.15983zm-6.84362,-4.16118l1.8506,1.85056l-2.31308,
          2.31304l2.3136,2.31354l-1.85063,1.85059l-2.31354,-2.31355l-2.31337,
          2.31342l-1.85057,-1.85061l2.31338,-2.31338l-2.31288,
          -2.31287l1.85056,-1.85057l2.31288,2.31288l2.31304,-2.31304z"
        />
      </svg>
    )
  }

  info () {
    const color = this.props.fill || '#5ABBD4'

    return (
      <svg
        class="icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
          fill={ color }
        />
        <path d="M10.97 15H12.97V17H10.97V15Z" fill={ color }/>
        <path
          d="M11.1288 13.7046H11.9762H12.8235V13.6526C12.8235 12.8123 13.0616 12.5602 13.5938 12.168L14.3081 11.6498C14.9804 11.1596 15.4005 10.5434 15.4005 9.57702C15.4005 8.0224 14.084 7 12.1793 7C10.3165 7 9 7.85434 9 9.73108V10.0812H10.7507V9.75909C10.7507 8.94677 11.2549 8.54061 12.1372 8.54061C12.9636 8.54061 13.4958 8.93276 13.4958 9.57702C13.4958 10.1372 13.1596 10.4033 12.6554 10.7675L12.0112 11.2437C11.3669 11.7199 11.1288 12.3781 11.1288 13.4145V13.7046Z"
          fill={ color }
        />
        <path
          d="M11.1288 13.7046H10.9788V13.8546H11.1288V13.7046ZM12.8235 13.7046V13.8546H12.9735V13.7046H12.8235ZM13.5938 12.168L13.5057 12.0466L13.5048 12.0473L13.5938 12.168ZM14.3081 11.6498L14.3962 11.7712L14.3965 11.771L14.3081 11.6498ZM9 10.0812H8.85V10.2312H9V10.0812ZM10.7507 10.0812V10.2312H10.9007V10.0812H10.7507ZM12.6554 10.7675L12.5676 10.6459L12.5663 10.6469L12.6554 10.7675ZM12.0112 11.2437L12.1003 11.3643L12.0112 11.2437ZM12.9735 13.7046V13.6526H12.6735V13.7046H12.9735ZM12.9735 13.6526C12.9735 13.2454 13.0315 13.0024 13.1388 12.8176C13.2478 12.6299 13.4171 12.4846 13.6828 12.2888L13.5048 12.0473C13.2384 12.2436 13.0225 12.4204 12.8794 12.6669C12.7346 12.9163 12.6735 13.2195 12.6735 13.6526H12.9735ZM13.6819 12.2895L14.3962 11.7712L14.22 11.5284L13.5057 12.0466L13.6819 12.2895ZM14.3965 11.771C14.7446 11.5172 15.0347 11.2254 15.2371 10.8655C15.4402 10.5046 15.5505 10.0832 15.5505 9.57702H15.2505C15.2505 10.0373 15.1508 10.4071 14.9757 10.7185C14.8 11.0308 14.5438 11.2923 14.2197 11.5286L14.3965 11.771ZM15.5505 9.57702C15.5505 8.75322 15.1999 8.06595 14.5974 7.58801C13.9978 7.11239 13.1571 6.85 12.1793 6.85V7.15C13.1061 7.15 13.8761 7.39881 14.411 7.82305C14.9429 8.24496 15.2505 8.8462 15.2505 9.57702H15.5505ZM12.1793 6.85C11.2277 6.85 10.3952 7.06788 9.79758 7.54449C9.19464 8.02534 8.85 8.75427 8.85 9.73108H9.15C9.15 8.83115 9.46362 8.19454 9.98463 7.77903C10.511 7.35928 11.2681 7.15 12.1793 7.15V6.85ZM8.85 9.73108V10.0812H9.15V9.73108H8.85ZM9 10.2312H10.7507V9.93122H9V10.2312ZM10.9007 10.0812V9.75909H10.6007V10.0812H10.9007ZM10.9007 9.75909C10.9007 9.38524 11.0154 9.1269 11.2108 8.959C11.4101 8.78774 11.7164 8.69061 12.1372 8.69061V8.39061C11.6757 8.39061 11.2887 8.49655 11.0153 8.73146C10.738 8.96971 10.6007 9.32061 10.6007 9.75909H10.9007ZM12.1372 8.69061C12.5288 8.69061 12.8333 8.78374 13.036 8.9369C13.2341 9.08662 13.3458 9.30108 13.3458 9.57702H13.6458C13.6458 9.2087 13.4913 8.90496 13.2168 8.69754C12.9468 8.49355 12.572 8.39061 12.1372 8.39061V8.69061ZM13.3458 9.57702C13.3458 9.8216 13.2743 9.99517 13.148 10.1515C13.0156 10.3154 12.8224 10.4619 12.5676 10.6459L12.7433 10.8891C12.9927 10.709 13.2196 10.5403 13.3814 10.34C13.5492 10.1322 13.6458 9.89266 13.6458 9.57702H13.3458ZM12.5663 10.6469L11.922 11.123L12.1003 11.3643L12.7446 10.8881L12.5663 10.6469ZM11.922 11.123C11.5784 11.377 11.3398 11.6829 11.189 12.0638C11.0393 12.4416 10.9788 12.8862 10.9788 13.4145H11.2788C11.2788 12.9065 11.3374 12.5037 11.4679 12.1743C11.5971 11.8479 11.7997 11.5865 12.1003 11.3643L11.922 11.123ZM10.9788 13.4145V13.7046H11.2788V13.4145H10.9788ZM11.1288 13.8546H11.9762V13.5546H11.1288V13.8546ZM11.9762 13.8546H12.8235V13.5546H11.9762V13.8546Z"
          fill={ color }
        />
      </svg>
    )
  }

  logInOptIn () {
    return (
      <svg
        class="icon"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        xmlns="https://www.w3.org/2000/svg">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path
            d="M9.799,8.7996 L11,7.6356 L15.425,11.9996 L11,16.3636
          L9.799,15.2006 L12,12.9996 L3,12.9996 L3,11.0006 L12,11.0006
          L9.799,8.7996 Z M11.9995,3 C16.9705,3 20.9995,7.029 20.9995,12
          C20.9995,16.971 16.9705,21 11.9995,21 C8.4675,21 5.4195,18.961
          3.9455,16 L6.2635,16 C7.5295,17.811 9.6265,19 11.9995,19 C15.8585,19
          18.9995,15.859 18.9995,12 C18.9995,8.14 15.8585,5 11.9995,5 C9.6265,5
          7.5295,6.189 6.2635,8 L3.9455,8 C5.4195,5.039
          8.4675,3 11.9995,3 Z"
            fill="#FFFFFF"
          />
        </g>
      </svg>
    )
  }

  passWrapper () {
    if (this.props.wrapperLevel === 0) {
      return (
        <svg
          class="icon"
          width="53"
          height="53"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <path
              class="shape"
              fill-rule="evenodd"
              clip-rule="evenodd"
              fill="#C79E57"
              d="M26.4444 0.333496C21.2581 0.333496 16.1883 1.8714
            11.8761 4.75274C7.56389 7.63407 4.20293 11.7294 2.21823
            16.5209C0.23353 21.3124 -0.285758 26.5848 0.726032
            31.6714C1.73782 36.758 4.23525 41.4304 7.90249
            45.0976C11.5697 48.7649 16.2421 51.2623 21.3287
            52.2741C26.4153 53.2859 31.6877 52.7666 36.4792
            50.7819C41.2707 48.7972 45.366 45.4362 48.2474
            41.124C51.1287 36.8118 52.6666 31.742 52.6666
            26.5557C52.6666 19.6012 49.9039 12.9314 44.9863
            8.01381C40.0687 3.09619 33.399 0.333496 26.4444
            0.333496ZM34.912 12.9353C35.8824 12.9353 36.8311 13.223
            37.638 13.7622C38.4449 14.3013 39.0738 15.0677 39.4451
            15.9642C39.8165 16.8608 39.9137 17.8474 39.7243
            18.7992C39.535 19.751 39.0677 20.6253 38.3815
            21.3115C37.6953 21.9977 36.821 22.465 35.8692
            22.6543C34.9174 22.8437 33.9308 22.7465 33.0343
            22.3751C32.1377 22.0037 31.3714 21.3748 30.8322
            20.5679C30.2931 19.761 30.0053 18.8124 30.0053
            17.8419C30.0052 17.1975 30.132 16.5594 30.3785
            15.964C30.6251 15.3686 30.9865 14.8275 31.4421
            14.3718C31.8977 13.9161 32.4387 13.5546 33.034
            13.308C33.6294 13.0613 34.2675 12.9344 34.912
            12.9344V12.9353ZM17.9768 12.9353C18.9473 12.9353
            19.8959 13.223 20.7028 13.7622C21.5097 14.3013 22.1386
            15.0677 22.51 15.9642C22.8814 16.8608 22.9786 17.8474
            22.7892 18.7992C22.5999 19.751 22.1326 20.6253 21.4464
            21.3115C20.7602 21.9977 19.8859 22.465 18.9341
            22.6543C17.9823 22.8437 16.9957 22.7465 16.0991
            22.3751C15.2026 22.0037 14.4363 21.3748 13.8971
            20.5679C13.358 19.761 13.0702 18.8124 13.0702
            17.8419C13.0701 17.1975 13.1969 16.5594 13.4434
            15.964C13.69 15.3686 14.0514 14.8275 14.507
            14.3718C14.9626 13.9161 15.5036 13.5546 16.0989
            13.308C16.6943 13.0613 17.3324 12.9344 17.9768
            12.9344V12.9353ZM26.4444 42.8526C22.696 42.8526
            19.1011 41.3636 16.4506 38.713C13.8001 36.0625
            12.3111 32.4677 12.3111 28.7193H40.5777C40.5777
            32.4677 39.0887 36.0625 36.4382 38.713C33.7877
            41.3636 30.1928 42.8526 26.4444 42.8526Z"
            />
          </g>
        </svg>
      )
    }
    else if (this.props.wrapperLevel === 1) {
      return (
        <svg
          class="icon icon-shifted"
          width="64"
          height="54"
          viewBox="0 0 64 54"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <path
              class="shape"
              fill-rule="evenodd"
              clip-rule="evenodd"
              fill="#C79E57"
              d="M50.8235 27.0002L45.1765 19.4707H48.9412C55.5953
            19.4707 64 11.9413 64 11.9413H43.2941L37.6471
            17.5884L41.4118 30.7649L50.8235 27.0002ZM39.2038
            0.647217H24.5873L22.5882 4.41192L32 15.706L41.4118
            4.41192L39.2038 0.647217ZM33.8824 19.4707L32
            21.3531L30.1176 19.4707L24.4706 47.706L32 53.3531L39.5294
            47.706L33.8824 19.4707ZM13.1765 27.0002L18.8235
            19.4707H15.0588C8.40471 19.4707 0 11.9413 0
            11.9413H20.7059L26.3529 17.5884L22.5882 30.7649L13.1765
            27.0002Z"
            />
          </g>
        </svg>
      )
    }
    else {
      return (
        <svg
          class="icon"
          width="54"
          height="54"
          viewBox="0 0 54 54"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <path
              class="shape"
              fill-rule="evenodd"
              clip-rule="evenodd"
              fill="#C79E57"
              d="M53.6668 15.0369C53.6668 44.2804 26.9999 53.5553
            26.9999 53.5553C26.9999 53.5553 0.333008 44.7745 0.333008
            15.0369V0.222168C0.333008 0.222168 15.4709 6.14793 26.9999
            6.14793C38.5288 6.14793 53.6668 0.222168 53.6668
            0.222168V15.0369ZM26.9999 44.6663C36.0751 44.6663 38.852
            35.7774 38.852 35.7774C35.224 37.7733 31.1404 38.7943
            26.9999 38.7406C19.3749 38.7406 15.1484 35.7774 15.1484
            35.7774C15.1484 35.7774 17.9253 44.6663 26.9999
            44.6663ZM12.1852 18.0001C18.0309 18.0001 21.0741 23.9258
            21.0741 23.9258C21.0741 23.9258 21.0626 29.8516 15.1484
            29.8516C9.70837 29.8516 6.25941 24.1223 6.25941
            20.9627C6.25941 17.9425 10.2012 18.0001 12.1852
            18.0001ZM41.8172 18.0001C35.766 18.0001 32.9282 23.9258
            32.9282 23.9258C32.9282 23.9258 32.9397 29.8516 38.854
            29.8516C44.294 29.8516 47.7429 24.1223 47.7429
            20.9627C47.7404 17.9425 43.7986 18.0001 41.8146
            18.0001H41.8172Z"
            />
          </g>
        </svg>
      )
    }
  }

  bubbleClose () {
    const color = this.props.fill || '#FFFFFF'

    return (
      <svg
        class="icon"
        width="18px"
        height="18px"
        viewBox="0 0 18 18"
        xmlns="https://www.w3.org/2000/svg">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path
            class="shape"
            fill={ color }
            d="M14 0L8 6L2 0L0 2L6 8L0 14L2 16L8 10L14 16L16 14L10 8L16 2L14 0Z"
          />
        </g>
      </svg>
    )
  }

  globe () {
    return (
      <svg
        class="icon"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        xmlns="https://www.w3.org/2000/svg">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path
            d="M9.383,19.551 C7.565,18.919 6.058,17.638 5.102,16 L8.339,16
          C8.58,17.37 8.937,18.583 9.383,19.551 Z M12,19.95 C11.563,19.606
          10.825,18.248 10.378,16 L13.622,16 C13.175,18.248 12.438,19.606
          12,19.95 Z M14.617,19.551 C15.064,18.583 15.42,17.37 15.661,16
          L18.899,16 C17.943,17.638 16.436,18.919 14.617,19.551 Z M4.279,14
          C4.112,13.358 4,12.694 4,12 C4,11.306 4.112,10.642 4.279,10 L8.084,10
          C8.031,10.647 8,11.313 8,12 C8,12.686 8.031,13.353 8.084,14 L4.279,14
          Z M10.096,14 C10.039,13.374 10,12.718 10,12 C10,11.281 10.039,10.626
          10.096,10 L13.904,10 C13.961,10.626 14,11.281 14,12 C14,12.718
          13.961,13.374 13.904,14 L10.096,14 Z M15.916,14 C15.969,13.353
          16,12.686 16,12 C16,11.313 15.969,10.647 15.916,10 L19.722,10
          C19.889,10.642 20,11.306 20,12 C20,12.694 19.889,13.358 19.722,14
          L15.916,14 Z M5.102,8 C6.058,6.362 7.565,5.081 9.383,4.448
          C8.937,5.416 8.58,6.63 8.339,8 L5.102,8 Z M15.661,8 C15.42,6.63
          15.064,5.416 14.617,4.448 C16.436,5.081 17.943,6.362 18.899,8
          L15.661,8 Z M10.378,8 C10.825,5.752 11.563,4.394 12,4.05
          C12.438,4.394 13.175,5.752 13.622,8 L10.378,8 Z M12,2 C6.478,2
          2,6.477 2,12 C2,17.523 6.478,22 12,22 C17.523,22 22,17.523 22,12
          C22,6.477 17.523,2 12,2 Z"
            class="shape"
          />
        </g>
      </svg>
    )
  }

  twitch () {
    return (
      <svg
        class="icon"
        width="19px"
        height="20px"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M81.6651 51.005L69.0015 63.0024H56.3318L45.2457 73.5053V63.0024H30.9985V18.0017H81.6651V51.005ZM27.831 12L12 26.9983V81.0015H30.9985V96L46.8295 81.0015H59.4992L88 53.9999V12H27.831ZM72.1689 28.9754H65.8338V46.973H72.1689V28.9754ZM48.4207 28.9049H54.7558V46.9048H48.4207V28.9049Z"
          fill="#9146FF"
        />
      </svg>
    )
  }

  youtube () {
    return (
      <svg
        class="icon"
        width="22px"
        height="16px"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <rect x="24" y="30" width="55" height="41" fill="white"/>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M41 62.8572V37.1428L63.3429 50L41 62.8572ZM91.2033 29.369C90.2137 25.6818 87.2999 22.777 83.5997 21.7914C76.893 20 49.9996 20 49.9996 20C49.9996 20 23.107 20 16.4003 21.7914C12.7001 22.777 9.78632 25.6818 8.79737 29.369C7 36.0534 7 50 7 50C7 50 7 63.9466 8.79737 70.631C9.78632 74.3182 12.7001 77.223 16.4003 78.2086C23.107 80 49.9996 80 49.9996 80C49.9996 80 76.893 80 83.5997 78.2086C87.2999 77.223 90.2137 74.3182 91.2033 70.631C93 63.9466 93 50 93 50C93 50 93 36.0534 91.2033 29.369Z"
          fill="#CB0000"
        />
      </svg>
    )
  }

  nimotv () {
    return (
      <svg
        class="icon"
        width="22px"
        height="22px"
        viewBox="0 0 22 22"
        xmlns="https://www.w3.org/2000/svg">
        <g>
          <path
            fill="#6F00ED"
            d="M21.4,7.69c-0.3-1.7-1.6-2.9-3.1-3.1c-1.6-0.2-3.2-0.4-4.9-0.5c1.2-1.7-0.5-3.3-0.5-3.3
            c-1.2,2.2-4.5,3.2-5,3.4c-1.4,0-2.8,0.2-4.2,0.4c-1.6,0.2-2.8,1.4-3.1,3.1c-0.7,3.3-0.7,6.6,0,9.9c0.3,1.7,1.6,2.9,3.1,3.1
            c4.9,0.7,9.7,0.7,14.6,0c1.5-0.2,2.8-1.5,3.1-3.1C22.1,14.29,22.1,10.99,21.4,7.69z"
          />
          <linearGradient
            id="SVGID_1_"
            gradientUnits="userSpaceOnUse"
            x1="11.5625"
            y1="11.1235"
            x2="11.5625"
            y2="6.3909"
            gradientTransform="matrix(1 0 0 -1 0 22)">
            <stop offset="0" style="stop-color:#FFE600"/>
            <stop offset="1" style="stop-color:#FFBB46"/>
          </linearGradient>
          <path
            fill="url(#SVGID_1_)"
            d="M14.1,12.49c-1.3-1.1-2.7-2-3.9-2.4c-0.5-0.2-1,0.1-1.1,0.6c-0.4,1.6-0.4,3.2,0,4.9c0.1,0.5,0.6,0.8,1.1,0.6
            c1.2-0.4,2.7-1.2,3.9-2.4C14.4,13.39,14.4,12.89,14.1,12.49z"
          />
          <ellipse fill="#FFFFFF" cx="6.7" cy="9.09" rx="1.2" ry="1.3"/>
          <path
            fill="#FFFFFF"
            d="M15.6,10.69c-0.1,0-0.2,0-0.3-0.1l-1.2-0.8c-0.1,0-0.2-0.1-0.3-0.2c-0.1-0.1-0.1-0.2-0.1-0.3s0-0.2,0.1-0.3
            s0.2-0.2,0.3-0.2l1.2-0.8c0.1-0.1,0.2-0.1,0.3-0.1s0.3,0.1,0.4,0.2c0.1,0.2,0.1,0.5-0.1,0.6l-0.8,0.6l0.8,0.6
            c0.2,0.1,0.3,0.4,0.1,0.6C15.9,10.59,15.8,10.69,15.6,10.69L15.6,10.69z"
          />
        </g>
      </svg>
    )
  }

  openrec () {
    return (
      <svg
        class="icon"
        width="22px"
        height="22px"
        viewBox="0 0 512 380"
        xmlns="https://www.w3.org/2000/svg">
        <defs>
          <clipPath id="clip-path-2">
            <path
              class="cls-2"
              fill="none"
              d="M254.36,0V75.44A115.34,115.34,0,1,1,139,190.78c0-62.67,50.27-113.72,112.59-115.2l-65.48-62.8c-71.62,27.48-122.55,96.71-122.55,178,0,105.36,85.42,190.78,190.78,190.78s190.78-85.42,190.78-190.78S359.73,0,254.36,0Z"
            />
          </clipPath>
          <clipPath id="clip-path-4">
            <path
              class="cls-2"
              fill="none"
              d="M139,190.78c0-62.67,50.27-113.72,112.59-115.2l-65.48-62.8c-71.62,27.48-122.55,96.71-122.55,178,0,105.36,85.42,190.78,190.78,190.78V306.12A115.47,115.47,0,0,1,139,190.78Z"
            />
          </clipPath>
        </defs>
        <path
          class="cls-4"
          fill="#ff4c11"
          d="M237.07,145 c-8.61,-5.11 -15.71,-1.14 -15.87,8.87 l-1.13,73.89 c-.15,10 6.83,14.21 15.59,9.36 l65.15,-36 c8.77,-4.85 8.89,-12.93 .28,-18 Z "
        />
        <g class="cls-5" clip-path="url(#clip-path-2)">
          <g class="cls-6" clip-path="url(#clip-path-3)">
            <image
              width="816"
              height="817"
              transform="translate(58.56 -5.28) scale(0.48)"
              href="data:image/png;base64,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"
            />
          </g>
        </g>
        <g class="cls-7" clip-path="url(#clip-path-4)">
          <g class="cls-8" clip-path="url(#clip-path-5)">
            <image
              width="419"
              height="790"
              transform="translate(58.56 7.68) scale(0.48)"
              href="data:image/png;base64,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"
            />
          </g>
        </g>
      </svg>
    )
  }

  mildom () {
    return (
      <svg
        class="icon"
        width="22px"
        height="22px"
        viewBox="0 0 147.02 109.94"
        xmlns="http://www.w3.org/2000/svg">
        <g>
          <g>
            <g>
              <path
                fill="#040000"
                d="M142.59,15,103.38,29.86a82.23,82.23,0,0,0-6.25-19.39L82.56,14.4C79,5.88,72.56.14,65.1,0,57-.16,49.82,6.34,46.1,16c-3.93-3.8-8.7-5.68-13.3-4.72C25.47,12.81,20.8,21.06,21,31L7.7,34.61s4.47,13.07,3.87,21.31S5.5,70.68,2.45,76.48L11.65,80,0,95.91l35.84-6.77,54.85,20.8a95.24,95.24,0,0,0,8.84-17L134,107.18a118.74,118.74,0,0,0,12.57-45.46C147.78,43.22,146.58,27,142.59,15Z"
              />
            </g>
            <g>
              <path
                fill="#fff"
                d="M135.67,19.75,96.82,34.83a61.34,61.34,0,0,0-5.61-18.36L12.26,36.56S15,47.37,14.48,54.62s-3.58,13-6.34,18.06L16.81,76,6.74,89.75l31-5.86,46.59,17.64a81.68,81.68,0,0,0,9-17.45l35.13,14.86A103.94,103.94,0,0,0,139,59.86C140,44,139,30.08,135.67,19.75Z"
              />
            </g>
            <path
              fill="#040000"
              d="M126.79,35.91,92.44,47A53.82,53.82,0,0,0,88,28.27l-70.63,12s2.19,8.62,1.53,15.15a35.54,35.54,0,0,1-4.69,15.32l9.33,2.92L17,83.52,40.1,78.9,81.4,91.85a92.63,92.63,0,0,0,9.12-21.18l31.17,12.55s4.61-8.85,5.92-23.66S126.79,35.91,126.79,35.91Z"
            />
            <path
              fill="#41bcd5"
              d="M125,41,91,52a50.88,50.88,0,0,0-4.3-20.34L20.35,42.76s2.06,7.91,1.44,13.9a32.08,32.08,0,0,1-4.41,14.06l10.24,3.13-4.49,6.72,16-3.2L80.53,90a81.24,81.24,0,0,0,9.12-21.52l31.1,12.55s3.91-7.5,5-20S125,41,125,41Z"
            />
            <g>
              <path
                fill="#040000"
                d="M44,36.48c1.91,15.33,9.63,26.84,19,27.07,11,.26,20.11-14.9,20.6-34Z"
              />
            </g>
            <g>
              <path
                fill="#040000"
                d="M22.71,41.47C26.34,53.06,34.87,61.62,43,59.83c7.85-1.73,12.75-12.57,11.87-24.12Z"
              />
            </g>
            <path
              fill="#040000"
              d="M60.5,71.61c.2.23,5.4,6.4,5.85,6.88s.65.54,1.18.29c11-5.26,17.35-12.63,20.23-22.16a.46.46,0,0,0-.17-.57.48.48,0,0,0-.59.05C79.66,63.29,72.46,67.78,60.94,71,60.5,71,60.3,71.38,60.5,71.61Z"
            />
            <path
              fill="#fff"
              d="M63,71.49l3.35,3.9c9.17-3.93,15.65-10,19.13-16.88A47.25,47.25,0,0,1,63,71.49Z"
            />
            <g>
              <path
                fill="#fff"
                d="M63.63,4.39C55.34,4.23,48.28,14.51,46.89,28,43.48,19.43,37.32,13.84,31.74,15c-6.69,1.36-10,11.86-7.4,23.45S34.48,58.31,41.18,57c3.88-.79,6.61-4.66,7.73-10,2.76,7.85,7.79,13.13,13.63,13.25,9.08.18,16.68-12.17,17-27.57S72.7,4.57,63.63,4.39Z"
              />
            </g>
            <g>
              <path
                fill="#040000"
                d="M71.89,31.83c-1.69.3-3.37-1.93-4-5.33s0-6.7,2-7a2.43,2.43,0,0,1,.66,0c-1.09-1.51-2.38-2.4-3.76-2.4-3.88,0-7,6.87-7,15.35s3.15,15.35,7,15.35,7-6.87,7-15.35a20.88,20.88,0,0,0-.11-2.64,2.62,2.62,0,0,1-1.74,2Zm-6.64,8c-.83.34-1.68-.17-2-1.23a2.07,2.07,0,0,1,.9-2.64c.95-.37,1.72.26,2,1.33a2.08,2.08,0,0,1-.9,2.52Z"
              />
            </g>
            <g>
              <path
                fill="#040000"
                d="M43.05,35.78c-.11-.58-.24-1.14-.39-1.69-.1,1.42-.66,2.46-1.54,2.58-1.26.18-2.56-1.42-3.08-3.82s-.11-4.7,1.32-4.86a1.62,1.62,0,0,1,.44,0c-1.13-1.37-2.38-2.07-3.55-1.79-2.63.63-3.85,5.93-2.73,11.83s4.17,10.18,6.8,9.55S44.18,41.68,43.05,35.78ZM37.9,42.47a1.52,1.52,0,0,1-1.31-1.33c-.18-.81,0-1.57.7-1.59s1.15.59,1.34,1.4S38.47,42.43,37.9,42.47Z"
              />
            </g>
          </g>
        </g>
      </svg>
    )
  }

  afreecatv () {
    return (
      <svg
        id="Layer_2"
        class="icon"
        width="22px"
        height="22px"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 378.77 215.21">
        <g id="Layer_1-2">
          <path
            class="cls-1"
            fill="#fff"
            stroke-width="0px"
            d="M271.17,0c-31.87,0-60.51,13.86-80.21,35.88-.84.95-2.3.95-3.14,0C168.11,13.86,139.48,0,107.61,0,48.18,0,0,48.18,0,107.61s48.18,107.61,107.61,107.61c31.87,0,60.51-13.86,80.21-35.88.84-.95,2.3-.95,3.14,0,19.7,22.02,48.34,35.88,80.21,35.88,59.43,0,107.61-48.18,107.61-107.61S330.6,0,271.17,0ZM271.17,163.56c-17.22,0-31.6-8.3-40.43-17.67-2.81-2.99-6.29-7.09-10.13-10.57-1.83-1.66-3.65-3.14-5.39-4.48-7.2-5.13-16.13-8.18-25.83-8.18s-18.63,3.05-25.83,8.18c-1.75,1.33-3.56,2.82-5.39,4.48-3.84,3.48-7.32,7.58-10.13,10.57-8.82,9.37-23.21,17.67-40.43,17.67-.44,0-.87-.02-1.31-.03-.74-.02-1.48-.04-2.22-.09-.51-.03-1.01-.08-1.51-.12-.3-.02-.6-.05-.89-.08-28.12-2.96-50.03-26.74-50.03-55.64v.24-.47.24c0-28.89,21.91-52.67,50.02-55.64.31-.03.63-.05.95-.09.48-.04.97-.08,1.45-.11.74-.04,1.48-.06,2.24-.09.43,0,.86-.03,1.29-.03,17.22,0,31.6,8.3,40.43,17.67,2.81,2.99,6.29,7.09,10.13,10.57,1.83,1.66,3.65,3.14,5.39,4.48,7.2,5.13,16.13,8.18,25.83,8.18s18.63-3.05,25.83-8.18c1.75-1.33,3.56-2.82,5.39-4.48,3.84-3.48,7.32-7.58,10.13-10.57,8.82-9.37,23.21-17.67,40.43-17.67.43,0,.85.02,1.28.03.75.02,1.51.04,2.25.09.47.03.95.06,1.42.11.33.02.67.05,1,.09,27.03,2.86,48.32,24.96,49.9,52.36,0,.18.02.36.03.53.02.51.03,1.02.04,1.53.01.76.02,1.52,0,2.28-.01.57-.01,1.15-.04,1.72,0,.12-.02.24-.02.36-1.52,27.45-22.83,49.63-49.91,52.49-.34.03-.68.06-1.02.09-.46.04-.93.08-1.39.11-.74.04-1.51.06-2.26.09-.43,0-.85.03-1.28.03v.02Z"
          />
        </g>
      </svg>
    )
  }

  trovo () {
    return (
      <svg
        class="icon"
        width="22px"
        height="22px"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M66.5522 28.1633L88.3094 31.2067C89.375 31.3871 90.3628 31.723 89.8693 32.9865L84.4363 46.9923C84.4363 46.9923 84.1766 47.6631 83.5784 48.0755C82.9802 48.4878 82.0185 48.5136 82.0185 48.5136L68.5796 49.3133C68.5796 49.3133 64.6546 49.571 62.2887 50.0357C59.9236 50.4995 57.6097 51.0931 55.4784 53.0791C53.347 55.065 52.2294 56.8706 51.3456 59.2182C50.4617 61.565 50.3838 65.9758 51.2157 68.2976C52.0476 70.6194 53.0613 72.2953 54.9849 73.7401C56.9084 75.1849 59.2483 75.5714 60.5997 75.5714C61.9511 75.5714 64.0053 75.2106 65.3047 74.2563C66.6041 73.302 68.7362 71.3933 68.7362 68.4272C68.7362 65.4612 67.1763 63.3979 64.5774 63.3979C61.9786 63.3979 61.6662 65.3065 61.6662 65.6158C61.6662 65.925 61.9778 67.0082 62.7838 67.6275C63.5897 68.2468 63.6416 69.2012 63.1993 69.6908C62.757 70.1805 62.1856 70.439 61.3797 70.439C60.5737 70.439 56.7266 69.4847 56.7266 64.7645C56.7266 60.0444 60.7555 56.8722 65.9548 56.8722C71.154 56.8722 76.9247 60.638 76.9247 69.2527C76.9247 77.8675 70.0364 82.5103 68.2947 83.5161C66.5529 84.522 62.3163 87 56.0254 87C49.7345 87 42.5857 84.5986 36.2688 78.9499C29.952 73.3012 28.263 65.2019 28.1323 64.531C28.0017 63.8602 27.2744 61.4619 27.1186 58.5473C26.9628 55.6328 27.0407 53.0791 27.1186 51.4281L17.7346 51.8147C17.7346 51.8147 15.7851 51.9951 15.2129 51.4281C14.6407 50.8604 14.4329 50.1903 14.2771 49.3906L10.0923 23.4948C10.0923 23.4948 9.88457 22.1023 10.0923 21.2769C10.3001 20.4514 11.21 20.5287 12.0678 20.606C12.9257 20.6833 39.336 24.2429 39.336 24.2429C39.336 24.2429 43.4947 20.8122 46.6406 18.852C49.7864 16.8918 54.2049 14.6973 55.6869 14.338C57.1689 13.9796 58.9359 13.6672 59.8197 14.7246C60.7036 15.782 61.1711 17.1753 61.1711 17.1753L63.7707 23.2621C63.7707 23.2621 65.0969 26.7186 66.5522 28.1633Z"
          fill="#46B97A"
        />
      </svg>
    )
  }

  chatOpen () {
    return (
      <svg
        class="icon"
        width="24px"
        height="23px"
        viewBox="0 0 24 23"
        xmlns="http://www.w3.org/2000/svg">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g transform="translate(-866.000000, -20.000000)">
            <g transform="translate(862.000000, 14.000000)">
              <path
                class="shape"
                fill="#687077"
                fill-rule="evenodd"
                d="M9,13.9998 L9,11.9998 L23,11.9998 L23,13.9998 L9,13.9998 Z
              M9,17.9998 L9,15.9998 L20,15.9998 L20,17.9998 L9,17.9998 Z
              M7.0006,6.0003 L3.9996,9.0003 L3.9996,20.9993 L7.0006,24.0003
              L9.0006,24.0003 L9.0006,28.9993 L15.0006,24.0003 L25.0006,24.0003
              L28.0006,20.9993 L28.0006,9.0003 L25.0006,6.0003 L7.0006,6.0003
              Z M6.0006,20.1713 L6.0006,9.8283 L7.8286,8.0003 L24.1726,8.0003
              L26.0006,9.8283 L26.0006,20.1713 L24.1726,21.9993
              L15.0006,21.9993 L14.2776,21.9993 L13.7196,22.4633
              L11.0006,24.7293 L11.0006,24.0003 L11.0016,21.9993
              L9.0006,21.9993 L7.8286,21.9993 L6.0006,20.1713 Z"
              />
            </g>
          </g>
        </g>
      </svg>
    )
  }

  chatClose () {
    return (
      <svg
        class="icon"
        width="24px"
        height="23px"
        viewBox="0 0 24 23"
        xmlns="https://www.w3.org/2000/svg">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g transform="translate(-866.000000, -20.000000)">
            <g transform="translate(862.000000, 14.000000)">
              <path
                class="shape"
                fill="#687077"
                fill-rule="evenodd"
                d="M17.41545,15.00005 L19.9506,17.5352 L18.5356,18.9502
              L16.00045,16.41505 L13.4656,18.9499 L12.0506,17.5349
              L14.58545,15.00005 L12.0506,12.4652 L13.4656,11.0502
              L16.00045,13.58505 L18.5356,11.0499 L19.9506,12.4649
              L17.41545,15.00005 Z M7.0006,6.0003 L3.9996,9.0003
              L3.9996,20.9993 L7.0006,24.0003 L9.0006,24.0003 L9.0006,28.9993
              L15.0006,24.0003 L25.0006,24.0003 L28.0006,20.9993
              L28.0006,9.0003 L25.0006,6.0003 L7.0006,6.0003 Z M6.0006,20.1713
              L6.0006,9.8283 L7.8286,8.0003 L24.1726,8.0003 L26.0006,9.8283
              L26.0006,20.1713 L24.1726,21.9993 L15.0006,21.9993
              L14.2776,21.9993 L13.7196,22.4633 L11.0006,24.7293
              L11.0006,24.0003 L11.0016,21.9993 L9.0006,21.9993
              L7.8286,21.9993 L6.0006,20.1713 Z"
              />
            </g>
          </g>
        </g>
      </svg>
    )
  }

  theater () {
    return (
      <svg
        class="icon"
        width="24px"
        height="18px"
        viewBox="0 0 24 18"
        xmlns="http://www.w3.org/2000/svg">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g transform="translate(-330.000000, -63.000000)" fill="#FFFFFF">
            <g transform="translate(16.000000, 19.000000)">
              <g transform="translate(314.000000, 41.000000)">
                <path
                  class="shape"
                  d="M2,15 L22,15 L22,19 L2,19 L2,15 Z M0,21 L24,21 L24,3
              L0,3 L0,21 Z M2,19 L22,19 L22,5 L2,5 L2,19 Z"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
  }

  sidebar () {
    return (
      <svg
        class="icon"
        width="24px"
        height="18px"
        viewBox="0 0 24 18"
        xmlns="http://www.w3.org/2000/svg">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g transform="translate(-330.000000, -114.000000)" fill="#FFFFFF">
            <g transform="translate(16.000000, 19.000000)">
              <g transform="translate(314.000000, 92.000000)">
                <path
                  class="shape"
                  d="M7,15 L22,15 L22,19 L7,19 L2,19 L2,5 L7,5 L7,15 Z M0,21
              L24,21 L24,3 L0,3 L0,21 Z M2,19 L22,19 L22,5 L2,5 L2,19 Z"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
  }

  missionIconFallback () {
    return (
      <svg
        class="icon"
        width="145px"
        height="145px"
        xmlns="https://www.w3.org/2000/svg"
        viewBox="0 0 145 145">
        <rect x="62.76" y="59.22" width="21.28" height="2.62"/>
        <rect x="62.76" y="65.96" width="21.28" height="2.62"/>
        <rect x="62.76" y="72.69" width="21.28" height="2.62"/>
        <path
          d="M57,47.62l-4,9.47v23.3H50.29l-5.07,
        4.76v7.07l5,5.16H90.47l3.32-3.11V58l3.87-8.45.12-.28v-1.6ZM51.31,
        94.76l-3.47-3.6V86.29L51.33,83H79.42l-2.28,2.14v7.07l2.45,2.54ZM91.17,
        57.38V93.14l-1.74,
        1.62h-6.2l-3.47-3.6V86.29l4.28-4V80.39H55.63V57.62l3.13-7.38H94.44Z"
        />
        <path d="M144,1V144H1V1H144m1-1H0V145H145V0Z"/>
      </svg>
    )
  }

  roleIcon () {
    switch (this.props.role) {
      case 'top':
        return (
          <svg
            class="icon"
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 400 400">
            <g>
              <path
                fill-rule="evenodd"
                fill="#555d64"
                d="M247.059,
              247.059V164.706H164.706v82.353h82.353ZM352.936,
              352.933V82.537l-47.054,
              46.875v176.47l-176.309.019L82.532,352.933h270.4Z"
              />
              <path
                fill-rule="evenodd"
                fill="#c79e57"
                d="M329.946,
              47.1l-59.358,58.787H105.882V270.588L47.1,329.945,47.059,47.059Z"
              />
            </g>
          </svg>
        )
      case 'jungle':
        return (
          <svg
            class="icon"
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 400 400">
            <path
              fill-rule="evenodd"
              fill="#c79e57"
              d="M294.118,
            35.294c-25.034,38.865-60.555,80.6-81.959,134.935,8.81,21.507,
            17.469,42.872,23.135,65.065,5.088-12.873,5.51-23.4,
            11.765-35.294C247,
            141.447,268.9,97.375,294.118,35.294m-141.177,
            200c-17.5-52.79-56-81.948-105.882-105.882,45.506,36.9,52.025,
            88.47,58.823,141.176l44.035,38.96c17.313,18.887,
            44.514,48.694,50.083,55.158,
            53.589-111.119-39.6-244.759-94.118-329.412C137.292,
            112.618,161.376,156.962,
            152.941,235.294Zm94.118,58.824c1.1,9.873-.075,13.739,0,
            23.529l47.059-47.059c6.8-52.706,13.318-104.28,
            58.823-141.176C290.728,159.259,260.4,221.817,
            247.059,294.118Z"
            />
          </svg>
        )

      case 'mid':
        return (
          <svg
            class="icon"
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 400 400">
            <g>
              <path
                fill-rule="evenodd"
                fill="#555d64"
                d="M305.755,199.6L352.9,152.569l0.039,200.372h-200L200,305.882H305.883Zm-58.7-152.541L199.753,94.1H94.1L94.117,200,47.065,246.79V47.068Z"
              />
              <path
                fill-rule="evenodd"
                fill="#c79e57"
                d="M105.882,352.941l247.06-247.059V47.059H294.118L47.059,294.117v58.824h58.823Z"
              />
            </g>
          </svg>
        )

      case 'bottom':
        return (
          <svg
            class="icon"
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 400 400">
            <g>
              <path
                fill-rule="evenodd"
                fill="#555d64"
                d="M152.942,152.941v82.353h82.352V152.941H152.942ZM47.064,47.067v270.4L93.6,270.436l0.52-176.318,176.31-.019,47.041-47.032H47.064Z"
              />
              <path
                fill-rule="evenodd"
                fill="#c79e57"
                d="M70.054,352.905l59.357-58.787H294.118V129.412L352.9,70.055l0.039,282.886Z"
              />
            </g>
          </svg>
        )

      case 'support':
        return (
          <svg
            class="icon"
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 400 400">
            <path
              fill-rule="evenodd"
              fill="#c8aa6e"
              d="M317.647,200l-35.294-47.059h23.53c41.584,0,94.117-47.058,94.117-47.058H270.588l-35.294,35.293,23.53,82.354ZM245.026,35.3H153.673l-12.5,23.523L200,129.412l58.823-70.588L245.026,35.3m-33.262,117.64L200,164.706l-11.765-11.765L152.941,329.412,200,364.706l47.059-35.294ZM82.353,200l35.294-47.059H94.118C52.533,152.941,0,105.883,0,105.883H129.412l35.294,35.293-23.53,82.354Z"
            />
          </svg>
        )

      default:
        return (
          <svg
            class="icon"
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 400 400">
            <path
              fill-rule="evenodd"
              fill="#c79e57"
              d="M58.824,223.529H341.176L364.706,200l-23.53-23.529H58.824L35.294,200Zm235.294,82.353L152.941,70.588,117.647,58.824,105.882,94.118,247.059,329.412l35.294,11.764Zm0-211.764L152.941,329.412l-35.294,11.764-11.765-35.294L247.059,70.588l35.294-11.765Z"
            />
          </svg>
        )
    }
  }

  externalLink () {
    return (
      <svg
        class="icon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 12H4V4H7V2H4C2.9 2 2 2.9 2 4V12C2 13.1 2.9 14 4 14H12C13.1 14 14 13.1 14 12V9H12V12ZM9 2V3.49L11.2545 3.24627L7.00177 7.49902L8.50082 8.99808L12.7523 4.74658L12.5 7H14V2H9Z"
        />
      </svg>
    )
  }

  cog () {
    const color = this.props.fill || '#687077'

    return (
      <svg
        class="icon"
        width="12"
        height="12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          class="shape"
          d="M6.6 -2.88495e-07L5.4 -2.36042e-07L4.74 1.986C4.506 2.052 4.266 2.142 4.032 2.256L2.184 1.332L1.338 2.178L2.262 4.026C2.154 4.266 2.064 4.5 1.992 4.734L-2.88495e-07 5.4L-2.36042e-07 6.6L1.998 7.266C2.07 7.5 2.166 7.722 2.274 7.932L1.332 9.816L2.184 10.668L4.068 9.726C4.278 9.834 4.5 9.93 4.734 10.002L5.4 12L6.6 12L7.26 10.014C7.494 9.948 7.734 9.858 7.968 9.744L9.816 10.668L10.662 9.822L9.738 7.974C9.846 7.734 9.936 7.5 10.008 7.266L12 6.6L12 5.4L10.002 4.734C9.93 4.5 9.834 4.278 9.726 4.068L10.668 2.184L9.822 1.338L7.938 2.28C7.728 2.172 7.5 2.076 7.272 2.004L6.6 -2.88495e-07ZM8.4 6C8.4 7.326 7.326 8.4 6 8.4C4.674 8.4 3.6 7.326 3.6 6C3.6 4.674 4.674 3.6 6 3.6C7.326 3.6 8.4 4.674 8.4 6Z"
          fill={ color }
        />
      </svg>
    )
  }

  checkmark () {
    return (
      <svg
        class="icon"
        width="12"
        height="10"
        fill="none"
        viewBox="0 0 12 10"
        xmlns="http://www.w3.org/2000/svg">
        <path
          class="shape"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.5 0L3.5 7L1.5 4.999L0 6.5L1.999 8.5L3.5 10L5 8.5L11.999 1.5L10.5 0Z"
          fill="#5ABBD4"
        />
      </svg>
    )
  }

  filter () {
    return (
      <svg
        class="icon"
        width="25"
        height="17"
        viewBox="0 0 25 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <line
          y1="1.91665"
          x2="24.2778"
          y2="1.91665"
          stroke="#687077"
          stroke-width="1.27778"
        />
        <line
          y1="8.30545"
          x2="24.2778"
          y2="8.30545"
          stroke="#687077"
          stroke-width="1.27778"
        />
        <line
          y1="14.6944"
          x2="24.2778"
          y2="14.6944"
          stroke="#687077"
          stroke-width="1.27778"
        />
        <circle cx="19.8056" cy="8.30546" r="1.91667" fill="#687077"/>
        <circle cx="4.47221" cy="1.91667" r="1.91667" fill="#687077"/>
        <circle cx="10.8611" cy="14.6944" r="1.91667" fill="#687077"/>
      </svg>
    )
  }

  riotBarSubMenuClose () {
    return (
      <svg class="icon" width="32" height="32" viewBox="0 0 32 32">
        <circle opacity=".07" cx="16" cy="16" r="16" fill="#F9F9F9"/>
        <g stroke="#C7C7C7" stroke-width="2">
          <path
            class="shape"
            d="M12.007 11.973l8.132 8.132M11.993 20.093l8.131-8.132"
          />
        </g>
      </svg>
    )
  }

  riotBarArrow () {
    if (this.props.direction === 'left') {
      return (
        <svg class="icon" width="5" height="8" viewBox="0 0 5 8">
          <path
            class="shape"
            d="M3.293 7.293L.707 4.707a1 1 0 0 1 0-1.414L3.293.707C3.923.077 5 .523 5 1.414v5.172c0 .89-1.077 1.337-1.707.707z"
            fill="#7E7E7E"
          />
        </svg>
      )
    }
    else if (this.props.direction === 'right') {
      return (
        <svg class="icon" width="5" height="9" viewBox="0 0 5 9">
          <path
            class="shape"
            d="M1.707 7.793l2.586-2.586a1 1 0 0 0 0-1.414L1.707 1.207C1.077.577 0 1.023 0 1.914v5.172c0 .89 1.077 1.337 1.707.707z"
            fill="#7E7E7E"
          />
        </svg>
      )
    }
  }

  lolesportsLogo () {
    return (
      <svg
        class="icon"
        xmlns="http://www.w3.org/2000/svg"
        width="38"
        height="38"
        viewBox="0 0 425 425">
        <path
          class="shape"
          fill="#FAFAFA"
          d="M94.73,94.85h94.12V47.37h-73c-37.83,0-68.49,30.74-68.49,68.66v73.17h47.37V94.85z M179.04,212.94
          l-84.31,84.51v-60.77H47.37v141.83h141.49v-47.48h-60.63l84.31-84.52L179.04,212.94z M330.34,331.03h-94.12v47.48h73
          c37.83,0,68.49-30.74,68.49-68.66v-73.17h-47.37V331.03z M236.22,47.37v47.48h60.63l-84.31,84.52l33.49,33.57l84.31-84.52v60.77
          h47.37V47.37H236.22z"
        />
      </svg>
    )
  }

  share () {
    return (
      <svg
        class="icon"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.002 9.465a4 4 0 1 0-5.855-2.393l-3.68 2.124a4.004 4.004 0 0 0-6.321.802A4 4 0 0 0 9.465 14.8l3.682 2.126a4.002 4.002 0 0 0 7.32 3.07 4 4 0 0 0-6.32-4.802l-3.682-2.126c.198-.71.19-1.45 0-2.14l3.681-2.125a4.002 4.002 0 0 0 4.855.66ZM18.733 5a2 2 0 1 1-3.465 2 2 2 0 0 1 3.464-2ZM8.341 12.998a2 2 0 1 1-3.464-2 2 2 0 0 1 3.464 2Zm10.392 6a2 2 0 1 1-3.464-2 2 2 0 0 1 3.464 2Z"
          fill="#000"
        />
      </svg>
    )
  }

  caret () {
    return (
      <svg
        class="icon"
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4,6.5 Q2.75,4.75,4,4.5 L12,4.5 Q13.25,4.75,12,6.5 L9,10.5 Q8,11.5,7,10.5 Z"
          fill="#a3a3a3"
        />
      </svg>
    )
  }

  circleDash () {
    return (
      <svg
        class="icon"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="10" fill="currentColor"/>
        <path
          fill="#000"
          fill-rule="evenodd"
          d="M4.792 8.958h10.417v2.083H4.792z"
          clip-rule="evenodd"
        />
      </svg>
    )
  }

  circleDashOutline () {
    return (
      <svg
        class="icon"
        fill="none"
        height="32"
        viewBox="0 0 32 32"
        width="32"
        xmlns="http://www.w3.org/2000/svg">
        <circle cx="16" cy="16" r="15" stroke="currentColor" stroke-width="2"/>
        <path fill="currentColor" d="M10,15 H22 V17 H10 Z"/>
      </svg>
    )
  }

  linkArrowIcon () {
    return (
      <svg
        class="icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <rect
          x="10.084"
          y="4.72168"
          width="2"
          height="12"
          transform="rotate(-45 10.084 4.72168)"
          fill="white"
        />
        <rect
          x="11.5"
          y="3.30762"
          width="2"
          height="12"
          transform="rotate(45 11.5 3.30762)"
          fill="white"
        />
        <path
          d="M11.499 4.72175L11.499 21.6923"
          stroke="white"
          stroke-width="2"
        />
      </svg>
    )
  }

  eventDropdownClose () {
    return (
      <svg
        class="icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g id="Icon=Close, Size=24" clip-path="url(#clip0_2875_91459)">
          <path
            id="Vector"
            d="M22 4.01429L19.9857 2L12 9.98571L4.01429 2L2 4.01429L9.98571 12L2 19.9857L4.01429 22L12 14.0143L19.9857 22L22 19.9857L14.0143 12L22 4.01429Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_2875_91459">
            <rect width="24" height="24" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    )
  }

  circleCheck () {
    return (
      <svg
        class="icon"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="10" fill="#fff"/>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.0625 4.75L7.1875 12.625L4.9375 10.3739L3.25 12.0625L5.49888 14.3125L7.1875 16L8.875 14.3125L16.7489 6.4375L15.0625 4.75Z"
          fill="#000"
        />
      </svg>
    )
  }

  activeCircle () {
    return (
      <svg
        class="icon"
        fill="none"
        height="20"
        viewBox="0 0 20 20"
        width="20"
        xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" fill="#dc3030" r="6"/>
        <circle
          cx="10"
          cy="10"
          fill="transparent"
          r="9"
          stroke-width="2"
          stroke="#dc3030"
        />
      </svg>
    )
  }

  eventCircle () {
    return (
      <svg
        class="icon"
        fill="none"
        height="20"
        viewBox="0 0 20 20"
        width="20"
        xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="9" stroke="#303030" stroke-width="2"/>
      </svg>
    )
  }

  kick () {
    return (
      <svg
        className="icon"
        clipRule="evenodd"
        fillRule="evenodd"
        height="16"
        strokeLinejoin="round"
        strokeMiterlimit="2"
        viewBox="0 0 512 512"
        width="16"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M37 .036h164.448v113.621h54.71v-56.82h54.731V.036h164.448v170.777h-54.73v56.82h-54.711v56.8h54.71v56.82h54.73V512.03H310.89v-56.82h-54.73v-56.8h-54.711v113.62H37V.036z"
          fill="#53fc18"
        />
      </svg>
    )
  }

  render () {
    // render icon if it exists, otherwise don't break the page
    return this[this.props.name] ? this[this.props.name]() : ''
  }
}

export default Icon
